import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/models'
)({
  component: ModelsLayout,
})

function ModelsLayout() {
  return <FeatureGate feature='image' />
}
